import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "alert alert-success text-center"
};
const _hoisted_2 = {
  class: "alert alert-info text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loading = _resolveComponent("Loading");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_Verify = _resolveComponent("Verify");
  const _component_b_modal = _resolveComponent("b-modal");
  return $props.payment ? (_openBlock(), _createBlock(_component_b_modal, {
    key: 0,
    id: "payment-confirm-modal",
    modelValue: $data.openModal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.openModal = $event),
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    title: "Confirm Payment",
    "ok-title": "Confirm Payment",
    "ok-variant": "success",
    "ok-disabled": $data.loading || !$options.isValid,
    size: "lg",
    onOk: $options.confirmPayment
  }, {
    default: _withCtx(() => [_createVNode(_component_Loading, {
      loading: $data.loading
    }, null, 8, ["loading"]), !$data.loading ? (_openBlock(), _createBlock(_component_b_row, {
      key: 0
    }, {
      default: _withCtx(() => [_createVNode(_component_b_col, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h4", null, [_cache[1] || (_cache[1] = _createElementVNode("i", {
          class: "glyphicon glyphicon-alert"
        }, null, -1)), _createTextVNode(" You are applying a payment for the Unpaid Balance of " + _toDisplayString($props.payment.status.localbalance.localcurrencyformatted), 1)]), _cache[2] || (_cache[2] = _createElementVNode("p", null, "Please Confirm Your Payment.", -1))])], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })) : _createCommentVNode("", true), !$data.loading && $options.amountDue > 0 && $props.payment.billing && $props.payment.billing.id ? (_openBlock(), _createBlock(_component_Verify, {
      key: 1,
      open: $data.openModal,
      card: $props.payment.billing,
      onIsValid: $options.setValidity,
      onUpdate: $options.setBillingCvc
    }, null, 8, ["open", "card", "onIsValid", "onUpdate"])) : _createCommentVNode("", true), !$data.loading ? (_openBlock(), _createBlock(_component_b_row, {
      key: 2,
      class: "mt-3"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_col, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", null, [_cache[3] || (_cache[3] = _createElementVNode("i", {
          class: "glyphicon glyphicon-alert"
        }, null, -1)), _createTextVNode(" Amount to be Billed: " + _toDisplayString($props.payment.status.localbalance.localcurrencyformatted), 1)])])], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })) : _createCommentVNode("", true)], undefined, true),
    _: 1
  }, 8, ["modelValue", "ok-disabled", "onOk"])) : _createCommentVNode("", true);
}